export interface RetryConfig {
  maxRetries: number
  backoffBaseMs: number
}

export class RetryManager {
  constructor(private readonly config: RetryConfig) {}

  async executeWithRetry<T>(operation: () => Promise<T>): Promise<T> {
    const maxAttempts = this.config.maxRetries + 1
    let lastError: Error

    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      try {
        return await operation()
      } catch (error) {
        lastError = error as Error

        if (attempt === maxAttempts - 1) {
          break
        }

        const delay = this.calculateBackoffDelay(attempt)
        await this.sleep(delay)
      }
    }

    throw lastError!
  }

  private calculateBackoffDelay(attempt: number): number {
    return this.config.backoffBaseMs * Math.pow(2, attempt)
  }

  private sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }
}
